import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
// Add your imports here
import Login from "pages/login";
import Dashboard from "pages/dashboard";
import CategoryManagement from "pages/category-management";
import CustomerManagement from "pages/customer-management";
import ProductCatalogManagement from "pages/product-catalog-management";
import OrderManagement from "pages/order-management";
import AddProduct from "pages/add-product";
import AddCategory from "pages/add-category";
import NotFound from "pages/NotFound";
import CustomerFeedbackManagement from "pages/customer-feedback-management";
import PrivacyPolicyManagement from "pages/privacy-policy-management";
import StoreInformationManagement from "pages/store-information-management";
import AdvertisementManagement from "pages/advertisement-management";
import CouponManagement from "pages/coupon-management";
import AdminDashboard from "pages/AdminDashboard";
//
import { LanguageProvider, useLanguage } from "./LanguageContext";
import Layout from "./components/layout/Layout";
import Homepage from "pages/Homepage";
import EditProduct from "pages/edit-product";
import AdminsManagment from "pages/admins-managment";
import NotificationsManagment from "pages/notifications";
import GovernoratesManagement from "pages/governorates-management";
import ShippingSettingsManagment from "pages/shipping-settings";
import SecondAdvertisementManagement from "pages/second-advertisment-managment";
import DicountProductCatalogManagement from "pages/discount-products";
import TermsAndConditionsManagment from "pages/terms-and-conditions";
import ReturnPolicyManagment from "pages/return-policy";
import AboutUsManagment from "pages/about-us";
import ContactUsManagment from "pages/contact-us";
const Routes = () => {
  //  const { direction } = useLanguage();
  const [isOpen, setIsOpen] = useState(false); // State to manage sidebar open/close

  /*  useEffect(() => {
    alert(direction)
    document.documentElement.dir = direction; // Set the document direction
  }, [direction]);*/

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Define your routes here 
          <Route path="/" element={<Homepage />} />*/}
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route
            path="/category-management"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <CategoryManagement />
              </Layout>
            }
          />
          <Route
            path="/customer-management"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <CustomerManagement />
              </Layout>
            }
          />

          <Route
            path="/admins-management"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <AdminsManagment />
              </Layout>
            }
          />
          <Route
            path="/product-catalog-management"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <ProductCatalogManagement />
              </Layout>
            }
          />

          <Route
            path="/discounted-product-catalog-management"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <DicountProductCatalogManagement />
              </Layout>
            }
          />
          <Route
            path="/edit-product"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <EditProduct />
              </Layout>
            }
          />
          <Route
            path="/order-management"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <OrderManagement />
              </Layout>
            }
          />
          <Route
            path="/add-product"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <AddProduct />
              </Layout>
            }
          />
          <Route
            path="/add-category"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <AddCategory />
              </Layout>
            }
          />
          <Route
            path="/privacy-policy-management"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <PrivacyPolicyManagement />
              </Layout>
            }
          />
          <Route
            path="/terms"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <TermsAndConditionsManagment />
              </Layout>
            }
          />
          <Route
            path="/return-policy"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <ReturnPolicyManagment />
              </Layout>
            }
          />

          <Route
            path="/about-us"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <AboutUsManagment />
              </Layout>
            }
          />

          <Route
            path="/contact-us"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <ContactUsManagment />
              </Layout>
            }
          />
          {/* <Route
            path="/customer-feedback-management"
            element={<CustomerFeedbackManagement />*/}
          <Route
            path="/admin-dashboard"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <AdminDashboard />
              </Layout>
            }
          />

          <Route
            path="/notifications"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <NotificationsManagment />
              </Layout>
            }
          />

          <Route
            path="/store-information-management"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <StoreInformationManagement />
              </Layout>
            }
          />
          <Route
            path="/advertisement-management"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <SecondAdvertisementManagement />
              </Layout>
            }
          />
          <Route
            path="/second-advertisement-management"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <SecondAdvertisementManagement />
              </Layout>
            }
          />
          <Route
            path="/coupon-management"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <CouponManagement />
              </Layout>
            }
          />
          <Route
            path="/governorates-management"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <GovernoratesManagement />
              </Layout>
            }
          />
          <Route
            path="/shipping-setting"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <ShippingSettingsManagment />
              </Layout>
            }
          />

          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

const App = () => (
  <LanguageProvider>
    <Routes />
  </LanguageProvider>
);

export default App;
